export const isStateLess = Component => !Component.prototype.render;
